/**
 * @Note
 * whenever you have to add a new color, use the following link
 * https://chir.ag/projects/name-that-color
 * to give name to the color.
 *
 * Also as a small refactor activity, the names which are not
 * standarized and named as above, should be named so
 */

const colors = require('tailwindcss/colors');
const themeColors = require('./themeColors');

module.exports = {
  gray: colors.slate, // this is needed because of color palette changes from v2 -> v3
  current: 'currentColor', // https://tailwindcss.com/docs/upgrade-guide#fill-and-stroke-use-color-palette
  grey: {
    background: '#E5E5E5',
  },
  brand: {
    yellow: {
      sunglow: '#FEC93B',
      chileanFire: '#F76F01',
      lightGold: '#FCF9F3',
      mediumGold: '#FAF6F0',
      gold: '#C09656',
      hold: '#FFC400',
      lightGold1: '#E3C188',
      babyYellow: '#FFFEF1',
    },
    grey: {
      base: '#757779',
      background: '#f5f5f8',
      dark: '#47494C',
      light: '#BDBDBD',
      menu: '#212529',
      nobel: '#B6B3B3',
      lightDark: '#E9ECEF',
      lightGreen: '#EAEEED',
      superLight: '#C2C2C2',
      special: '#393E54',
      newlight: '#828CA5',
      extraLight: '#F3F4F6',
    },
    black: '#191C1F',
    blue: {
      azureRadiance: '#017AFF',
      cerulean: '#01A9F4',
      base: '#1366e8',
      link: '#1890ff',
      dark: '#283964',
      lightBackground: '#F8F9FE',
      extraDark: '#101C3D',
      cornFlower: '#283964', // "dark blue in figma"
      lightPurple: '#EEEBF0',
      navy: '#244461',
      magenta: '#523465',
      dodger: '#3C92FF',
      chambray: '#363795',
      bahama: '#005C97',
      denim: '#0E65D7',
      sail: '#A8C6FC',
      darkPurple: '#293275',
      babyBlue: '#F3FAFF',
    },
    white: '#ffffff',
    line: '#E8EAED',
    green: {
      base: '#5AC69A',
      dark: '#089958',
      malachite: '#1CD860',
      extraDark: '#2D544B',
      ticker: '#1FD896',
      fillStart: '#3BB881',
      fillEnd: '#089959',
      babyGreen: '#F8FFF5',
    },
    red: {
      cinnabar: '#DF3C27',
      carnation: '#F74F4F',
      maroon: '#6B2F3E',
      canon: '#853C4F',
      lightpink: '#EEBED3',
      failure: '#D3637F',
      failureGr: '#C65350',
    },
    orange: {
      pending: '#F4AD5B',
      pendingfr: '#D98F56',
    },
    tertiary: {
      grey: '#f5f7f9',
      orange: '#FDF0E3',
      blue: '#E8F4FD',
      red: '#FAEAEA',
      green: '#EBF4EC',
      gold: '#FCF8F3',
    },
    pink: {
      champagne: '#F5DFCE',
    },
    tango: '#ED7B1C',
  },
  chart: {
    yellow: '#FFC40D',
    blue: '#017AFF',
    orange: '#FF6631',
  },
  light: {
    orange: '#FBF0E4',
    blue: '#EAF4FC',
    red: '#F7EBEA',
  },
  ...themeColors,
};
